export default __webpack_public_path__ + "assets/img/2e6b38e5cd0d06c9e6abccf933d78c80.svg";